
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Site"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"site"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Theme"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MetaTag"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TopCities"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LoggedOutHeader"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"viewer"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LoggedInHeader"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LoggedInViewer"},"directives":[]}]}}]}}],"loc":{"start":0,"end":525}};
    doc.loc.source = {"body":"#import 'components/api/fragments/ThemeFragment.gql'\n#import 'components/api/fragments/MetaTagFragment.gql'\n#import 'components/api/fragments/TopCitiesFragment.gql'\n#import 'components/api/fragments/LoggedOutHeaderFragment.gql'\n#import 'components/api/fragments/LoggedInHeaderFragment.gql'\n#import 'components/api/fragments/LoggedInViewerFragment.gql'\n\n\nquery Site {\n  site {\n    _id\n    ...Theme\n    ...MetaTag\n    ...TopCities\n    ...LoggedOutHeader\n  }\n  viewer {\n    _id\n    ...LoggedInHeader\n    ...LoggedInViewer\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require('components/api/fragments/ThemeFragment.gql').definitions));
doc.definitions = doc.definitions.concat(unique(require('components/api/fragments/MetaTagFragment.gql').definitions));
doc.definitions = doc.definitions.concat(unique(require('components/api/fragments/TopCitiesFragment.gql').definitions));
doc.definitions = doc.definitions.concat(unique(require('components/api/fragments/LoggedOutHeaderFragment.gql').definitions));
doc.definitions = doc.definitions.concat(unique(require('components/api/fragments/LoggedInHeaderFragment.gql').definitions));
doc.definitions = doc.definitions.concat(unique(require('components/api/fragments/LoggedInViewerFragment.gql').definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["Site"] = oneQuery(doc, "Site");
        
